module.exports = __webpack_public_path__ + "static/media/quickhelp.7fd66714.png";